import React from 'react';
import { Users, Target, Heart } from 'lucide-react';
import Card3D from './ui/Card3D';
import SectionBackground from './ui/SectionBackground';
import { colors } from '../styles/theme';

const About: React.FC = () => {
  return (
    <section id="about" className="relative py-20 bg-gray-50">
      <SectionBackground variant="both" color={colors.tertiary} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">About Us</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our commitment to a digital future that is inclusive and accessible to all students.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          <Card3D>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow h-full">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <Users className="h-6 w-6 text-[#0139B7]" />
              </div>
              <h3 className="text-xl font-bold mb-4">Our Mission</h3>
              <p className="text-gray-600">
                Reduce the digital divide and ensure equal opportunities for all students.
              </p>
            </div>
          </Card3D>

          <Card3D>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow h-full">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <Target className="h-6 w-6 text-[#0139B7]" />
              </div>
              <h3 className="text-xl font-bold mb-4">Our Vision</h3>
              <p className="text-gray-600">
                A world where every student has access to the digital tools necessary for their success.
              </p>
            </div>
          </Card3D>

          <Card3D>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow h-full">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <Heart className="h-6 w-6 text-[#0139B7]" />
              </div>
              <h3 className="text-xl font-bold mb-4">Our Values</h3>
              <p className="text-gray-600">
                Solidarity, innovation, and commitment to a positive social impact.
              </p>
            </div>
          </Card3D>
        </div>
      </div>
    </section>
  );
};

export default About;